<template>
  <div class="bg-image secondary"></div>
  <div class="bg-image primary"></div>
  <div class="container">
    <img :src="currentLogo" alt="Logo" class="logo" />
    <div class="buttons">
      <a href="https://studentmaker.basakansoft.com/en/privacy_policy.html" class="text-button">隱私權政策</a>
      |
      <a href="https://studentmaker.basakansoft.com/en/terms.html" class="text-button">使用條款</a>
      |
      <a href="https://caring-challenge-9d3.notion.site/Information-on-probability-based-items-14cc3e34652d80119487eb27ceb385ee?pvs=4" target="_blank" class="text-button">機率型道具資訊</a>
    </div>
    <div class="image-buttons">
      <a href="https://play.google.com/store/apps/details?id=com.basakansoft.koreanstudentsimulator">
        <img src="@/assets/google_play_black.png" alt="Google Play" />
      </a>
      <a href="https://apps.apple.com/app/korean-student-simulator/id6739276949">
        <img src="@/assets/app_store_black.png" alt="App Store" />
      </a>
    </div>
  </div>
  <div class="footer">
    <img src="@/assets/basakansoft.png" class="company-logo" />
    <div class="taiwan-warning">
      <img src="/tw_grade_icon/index_icon_01637359399210901177637522872720705089.jpg" alt="Taiwan Game Rating" class="rating-icon" />
      <div class="warning-text">
        <p>遊戲警語：</p>
        <p>請注意遊戲時間，避免沉迷。</p>
        <p>如以購買遊戲點數（卡）、虛擬遊戲幣或虛擬寶物等作為付費方式者，應標示其內容及金額。</p>
        <p>遊戲內容或服務中需另行支付費用之部分或其他類似警語。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeTw",
  data() {
    return {
      wallpaperList: [
        require('@/assets/wallpaper/wallpaper204.png'),
        require('@/assets/wallpaper/wallpaper6.png'),
        require('@/assets/wallpaper/wallpaper1001.png'),
        require('@/assets/wallpaper/wallpaper183.png'),
      ],
      transitionDelay: 4000,
      currentIndex: 0,
    };
  },
  computed: {
    currentLogo() {
      return require('@/assets/logo.tw.png');
    }
  },
  mounted() {
    this.initBackgroundSwitch();
    this.animateBounceInfinite();
  },
  methods: {
    initBackgroundSwitch() {
      const primaryDiv = document.querySelector('.primary');
      const secondaryDiv = document.querySelector('.secondary');
      const switchBackground = () => {
        this.currentIndex = (this.currentIndex + 1) % this.wallpaperList.length;
        secondaryDiv.style.backgroundImage = `url(${this.wallpaperList[this.currentIndex]})`;
        primaryDiv.style.opacity = '0';
        setTimeout(() => {
          this.currentIndex = (this.currentIndex + 1) % this.wallpaperList.length;
          primaryDiv.style.backgroundImage = `url(${this.wallpaperList[this.currentIndex]})`;
          primaryDiv.style.opacity = '1';
        }, this.transitionDelay);
      };
      switchBackground();
      setInterval(switchBackground, this.transitionDelay * 2);
    },
    animateBounceInfinite() {
      const logo = document.querySelector('.logo');
      const animate = () => {
        logo.classList.add('animate-bounce');
        setTimeout(() => {
          logo.classList.remove('animate-bounce');
        }, 2500);
      };
      animate();
      setInterval(animate, 5000);
    },
  }
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';

body, html {
  margin: 0;
  padding: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  filter: blur(12px);
  isolation: isolate;
  transition: opacity 1s ease-in-out;
}

.bg-image::after {
  content: '';
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(
      to right,
      rgba(255, 250, 233, 0.3) 0%,
      rgba(255, 250, 233, 0.8) 20%,
      rgba(255, 250, 233, 0.9) 50%,
      rgba(255, 250, 233, 0.8) 80%,
      rgba(255, 250, 233, 0.3) 100%
  );
}

@media (max-width: 800px) {
  .bg-image::after {
    background: linear-gradient(
        to right,
        rgba(255, 250, 233, 0.65) 0%,
        rgba(255, 250, 233, 0.8) 25%,
        rgba(255, 250, 233, 0.9) 50%,
        rgba(255, 250, 233, 0.8) 75%,
        rgba(255, 250, 233, 0.65) 100%
    );
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 98vh;
  position: relative;
  padding-bottom: 180px;
}

@media (max-width: 800px) {
  .container {
    padding-bottom: 200px;
  }
}

.logo {
  margin-bottom: 20px;
  width: 280px;
}

.animate-bounce {
  animation: bounce 2s;
}

.text-button {
  margin: 5px;
  color: #4D2600;
  text-decoration: none;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  outline: none;
}

a {
  font-family: 'Roboto', sans-serif;
}

.buttons {
  margin-bottom: 20px;
}

.image-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.image-buttons a img {
  margin: 5px;
  width: 150px;
  cursor: pointer;
}

.footer {
  position: absolute;
  bottom: 10px;
  text-align: center;
  color: gray;
  font-size: 11px;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.taiwan-warning {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  max-width: 800px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.rating-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
  flex-shrink: 0;
}

.warning-text {
  text-align: left;
  color: #4D2600;
  font-size: 11px;
  line-height: 1.5;
}

.warning-text p {
  margin: 4px 0;
}

.warning-text p:first-child {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
}

@media (max-width: 800px) {
  .taiwan-warning {
    flex-direction: column;
    align-items: center;
    max-width: 90%;
    padding: 12px;
  }

  .rating-icon {
    width: 60px;
    height: 60px;
  }

  .warning-text {
    text-align: center;
    font-size: 10px;
  }
}

.company-logo {
  width: 110px;
  margin-bottom: 15px;
}
</style>
